import { render, staticRenderFns } from "./PerformedWork.vue?vue&type=template&id=428c9e91&scoped=true&"
import script from "./PerformedWork.vue?vue&type=script&lang=ts&"
export * from "./PerformedWork.vue?vue&type=script&lang=ts&"
import style0 from "./PerformedWork.vue?vue&type=style&index=0&id=428c9e91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428c9e91",
  null
  
)

/* custom blocks */
import block0 from "./PerformedWork.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports